export const HAP_PHOTO_NUM_LIMIT_PER_PAGE = 4;
export const HAP_PHOTO_HEADER_DIVIDING_MARK = '-';
export const HAP_ITEMS_PER_PAGE_DEFAULT = 10;
export const HAP_ITEMS_PER_PAGE_LIMIT = 20;
export const HAP_CURRENT_PAGE_DEFAULT = 1;
